module.exports = __webpack_public_path__ + "static/monei_pay_3-da3d430dec2018935ec9cd7be620026c.png";